import React from 'react';
import { printPDF, printSpreadSheet } from '../../../api/risapi';

const DocumentsReport = ({ reportLoading, setReportLoading }) => {

    const fetchPdf = async () => {
        setReportLoading(true);
        const reportParameters = {
            selectedOption: "documents-list",
            reportType: "abstract",
            reportFormat: 'pdf'
        };

        printPDF('/api/parameter-report/workspace', reportParameters, () => {
            setReportLoading(false);
        });
    };

    const fetchSpreadSheet = async () => {
        setReportLoading(true);
        const reportParameters = {
            selectedOption: "documents-list",
            reportType: "abstract",
            reportFormat: 'spreadsheet'
        };

        printSpreadSheet('/api/parameter-report/workspace', reportParameters, () => {
            setReportLoading(false);
        });
    };

    return (
        <div className="m-md-3 mt-3 mt-md-0 btn-group btn-rtl">
            <button aria-expanded="false" className="btn btn-outline-primary dropdown-toggle" data-bs-toggle="dropdown" type="button">
                Reports <i className="ti ti-arrow-big-down-line" />
            </button>
            <ul className="dropdown-menu">
                <li>
                    <a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); fetchPdf(); }}>
                        PDF Report
                        <i className="ms-3 fa-solid fa-file-pdf fa-fw"></i>
                    </a>
                </li>
                <li>
                    <a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); fetchSpreadSheet(); }}>
                        SpreadSheet
                        <i className="ms-1 fa-solid fa-file-excel fa-fw" />
                    </a>
                </li>
            </ul>
        </div>
    );
};

export default DocumentsReport;
